import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {$t} from '../../helpers/translator';
import api from "../../helpers/api";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import DataTable from "../miscellaneous/DataTable/DataTable";
import {getClinics} from "../../store/data-slice";
import Modal from "../miscellaneous/Modal/Modal";
import StaffMemberAdd from "../StaffMemberAdd/StaffMemberAdd";
import {Link} from "react-router-dom";
import _ from "lodash";
import moment from "moment";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import Input from "../miscellaneous/Input/Input";
import {FaEdit} from 'react-icons/fa';
import StaffDelete from '../clinic/StaffDelete/StaffDelete';
import HasPermission from 'helpers/permissions/HasPermission';

const StaffMembersTable = (props) => {
    const dispatch = useDispatch();
    const userType = useSelector((state) => state.auth.role)

    const [payload, setPayload] = useState({
        clinicId: '',
        sort: 'last_treatment',
        order: 'desc',
        search: '',
        page: 1,
        per_page: 15,
    });

    const [addStaffModalShow, setAddStaffModalShow] = useState(false);
    const [editStaffModalShow, setEditStaffModalShow] = useState(false);
    const [staffToEdit, setStaffToEdit] = useState(null);

    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState([]);
    const [clinicOptions, setClinicOptions] = useState([])
    const [clinicOptionsSelected, setClinicOptionsSelected] = useState([])

    const [loading, setLoading] = useState(false);
    const [showAddStaffMemberModal, setShowAddStaffMemberModal] = useState(false)

    const [modalKey, setModalKey] = useState(0)


    useEffect(async () => {
        await getStaffMembers();
        // console.log('useEffect! store:', store.getState());
    }, [payload, clinicOptionsSelected]);

    useEffect(async () => {
        await getClinicOptions()
    }, [dispatch])      // like []


    const getAPIUrl = () => {
        return `staff?clinic_id=${payload.clinicId}&sort=${payload.sort}&order=${payload.order}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}`;
    }

    async function getStaffMembers() {
        setLoading(true)

        try {
            let res = await api.get(getAPIUrl());
            if (!res.success) {
                return;
            }

            let data = res.data.data.data;
            _.forEach(data, (v, k) => {
                const row = {...v};
                v.actionsComponent = <div className="d-flex justify-content-center" style={{gap: '7px'}}>
                <HasPermission permission="staff.edit">
                    <Tooltip content={$t('global.staff.editStaffDetails')}>
                        <FaEdit onClick={(e) => {
                            editStaff(row)
                        }}/>
                    </Tooltip>
                </HasPermission>
                <HasPermission permission="staff.delete">
                    <Tooltip content={$t('global.staff.deleteStaffMember')}>
                        <StaffDelete id={v.staff_id} patientName={v.staff_name} patientId={v.staff_personal_id} onSuccess={getStaffMembers.bind(this)} />
                    </Tooltip>
                </HasPermission>
                
            </div>;
                v.staff_name = v.staff_id ? <Tooltip content={$t('global.staff.goToStaff')}><Link
                    to={`/staff/${v.staff_id}`}>{v.staff_name}</Link></Tooltip> : '';
                v.clinic_name = v.staff_id ? <Link to={`/clinic/${v.clinic_id}`}>{v.clinic_name}</Link> : '';
                v.created_at = v.created_at ? moment(v.created_at).format('ll') : '-';
                //v.created_at = <Timestamp time={v.created_at}/>
                v.last_treatment = v.last_treatment ? moment(v.last_treatment).format('ll') : '-';
                //v.last_treatment = <Timestamp time={v.last_treatment}/>
            })

            setData(data);
            setPagination(res.data.data.pagination)
            // console.log('state', data, pagination, payload)
        } catch (e) {
            console.error('err get staff:', e);
        } finally {
            setLoading(false)
        }
    }

    async function getClinicOptions() {
        let res = await dispatch(getClinics())
        let clinics = [...res];
        clinics.unshift({
            value: '',
            label: $t('global.staff.allClinics'),
        })
        setClinicOptions(clinics);
        setClinicOptionsSelected(clinics[0])
    }

    async function dataTableActionHandler(data) {
        // console.log('dataTableActionHandler', data)
        if (data.key === 'page') {
            setPayload({...payload, page: data.value})
        } else if (data.key === 'header') {
            let order = 'desc'
            if (payload.sort === data.value) {
                order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            setPayload({...payload, sort: data.value, order: order})
        }
    }

    function searchHandler(e) {
        // console.log('current search string in parent: ', e.target.value)
        setPayload({...payload, page: 1, search: e.target.value})
    }

    const renderCreateEditStaffModal = () => {
        if (addStaffModalShow || editStaffModalShow) {
            return (
                <Modal content={<StaffMemberAdd mode={editStaffModalShow ? 'edit' : 'add'}
                                                   userType={userType}
                                                   staff={staffToEdit}
                                                   onSuccess={onModalSuccess.bind(this)}
                                                   emitClose={onModalSuccess.bind(this)}
                                                   visible={addStaffModalShow || editStaffModalShow}
                                                   />
                                }
                       onClose={(e) => {
                           closeModals()
                       }}
                       visible={addStaffModalShow || editStaffModalShow}/>
            );
        }
        return null;
    }

    const editStaff = (staff) => {
        setStaffToEdit({
            id: staff.staff_id,
            name: staff.staff_name,
            email: staff.staff_email,
            clinic_id: staff.clinic_id,
            personalId: staff.staff_personal_id
        });
        setEditStaffModalShow(true);
    }

    const addStaff = () => {
        setStaffToEdit(null);
        setAddStaffModalShow(true);
    }

    const closeModals = () => {
        setAddStaffModalShow(false);
        setEditStaffModalShow(false);
    }

    const onModalSuccess = () => {
        closeModals();
        getStaffMembers();
    }


    let tableSorted = {
        id: payload.sort,
        desc: payload.order === 'desc'
    }

    let tableHeaders = [
        {
            name: $t('global.staff.name'),
            id: 'staff_name',
            clickable: true
        },
        {
            name: $t('global.staff.personal_id'),
            id: 'staff_personal_id',
            clickable: true
        },
        {
            name: $t('global.staff.email'),
            id: 'staff_email',
            clickable: true
        },
        {
            name: $t('global.staff.treatments'),
            id: 'treatments',
            clickable: true
        },
        props.userType > 2 && {
            name: $t('global.staff.clinic'),
            id: 'clinic_name',
            clickable: true
        },
        {
            name: $t('global.staff.last_treatment'),
            id: 'last_treatment',
            clickable: true
        },
        {
            name: $t('global.staff.created_at'),
            id: 'created_at',
            clickable: true
        },
        {
            name: '',
            id: 'actionsComponent',
            clickable: false
        }
    ];

    if (userType === 2) {
        tableHeaders.splice(4, 1);
    }

    return (
        <>
            {renderCreateEditStaffModal()}
            <div className={'container'}>
                <div className={'box'}>
                    <div className={'alma-box'}>
                        <div className={'alma-box-header'}>
                            <div>
                                <h3>{props.header}</h3>
                            </div>
                            <HasPermission permission="staff.create">
                                <div id='addStaffButton' className={'secondary-button'} onClick={() => addStaff()}>
                                    {$t('global.staff.addStaffMember')}
                                </div>
                            </HasPermission>
                        </div>

                        <div className={'alma-fields-row'}>
                            {
                                !props.clinicId && !props.platformId && props.userType !== 2 ?
                                    <div className={'alma-field-container'}>
                                        <div className={'alma-field-header'}>{$t('global.service.byClinic')}</div>
                                        <MultiSelect
                                            options={clinicOptions}
                                            selected={clinicOptionsSelected}
                                            onValueChange={(data) => {
                                                setClinicOptionsSelected(data);
                                                setPayload({...payload, clinicId: data.value, page: 1});
                                            }
                                            }
                                        />
                                    </div>
                                    :
                                    null
                            }

                            {/*<div className={'alma-field-container'}>*/}
                                {/*<div className={'alma-field-header'}>{$t('global.staff.search')}</div>*/}
                                {/*<input name="search"*/}
                                {/*    // disabled={tableLoading}*/}
                                {/*       className={`${'alma-input'}`}*/}
                                {/*       type="text"*/}
                                {/*       value={payload.search}*/}
                                {/*       placeholder={$t('global.staff.searchForStaffMember')}*/}
                                {/*       onChange={(e) => searchHandler(e)}/>*/}
                            {/*</div>*/}

                            <div className={'alma-field-container'}>
                                <div className={'alma-field-header'}>{$t('global.staff.search')}</div>
                                <Input name="search"
                                    // disabled={tableLoading}
                                    delay={500}
                                    className={`${'alma-input'}`}
                                    type="text"
                                    value={payload.search}
                                    placeholder={$t('global.staff.searchForStaffMember')}
                                    onChange={(e) => searchHandler(e)}/>
                            </div>
                        </div>

                        <DataTable data={data}
                                headers={tableHeaders}
                                pagination={pagination}
                                loading={loading}
                                sorted={tableSorted}
                                apiUrl={getAPIUrl()}
                                onAction={(e) => dataTableActionHandler(e)}/>
                    </div>
                </div>
            </div>
        </>
    );

}

StaffMembersTable.defaultProps = {
    userType: 2,
    clinicId: null,
    header: $t('global.staff.staffMembers')
}

export default StaffMembersTable;
